export const actionTypes = {
  REQUEST_START: 'CONTACTS.APPOINTMENT.LIST.REQUEST_START',
  REQUEST_SUCCESS: 'CONTACTS.APPOINTMENT.LIST.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'CONTACTS.APPOINTMENT.LIST.REQUEST_FAILURE',
  CANCEL_REQUEST_START: 'CONTACTS.APPOINTMENT.CANCEL.REQUEST_START',
  CANCEL_REQUEST_SUCCESS: 'CONTACTS.APPOINTMENT.CANCEL.REQUEST_SUCCESS',
  CANCEL_REQUEST_FAILURE: 'CONTACTS.APPOINTMENT.CANCEL.REQUEST_FAILURE',
  SET: 'CONTACTS.APPOINTMENT.LIST.SET',
};

export function set(data) {
  return {
    type: actionTypes.SET,
    payload: data,
  };
}

export function startRequest(bookId) {
  return {
    type: actionTypes.REQUEST_START,
    payload: bookId,
  };
}

export function requestSuccess(data, bookId) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: {
      data,
      bookId,
    },
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function startCancelRequest(bookId) {
  return {
    type: actionTypes.CANCEL_REQUEST_START,
    payload: bookId,
  };
}

export function cancelRequestSuccess(bookId) {
  return {
    type: actionTypes.CANCEL_REQUEST_SUCCESS,
    payload: { bookId },
  };
}

export function cancelRequestFailure(error) {
  return {
    type: actionTypes.CANCEL_REQUEST_FAILURE,
    payload: error,
  };
}
